<template>
  <div id="myPkIndex" style="height: 100vh;overflow: auto">
    <router-view></router-view>
    <PkFitMenu :routeQueries="routeQueries"></PkFitMenu>
  </div>
</template>

<script>
export default {
  name: 'myPkIndex',
  data () {
    return {
      openId: '',
      routeQueries: {},
      oriUrl: this.$route.query.returnurl || '',
      takedacode: this.$route.query.takedacode || ''
    }
  },
  created () {
    // if (!localStorage.TaToken && !this.takedacode) {
    //   let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/myPkHome?returnurl=' + encodeURIComponent((this.oriUrl || '')))
    //   window.location.href = url
    // } else {
    //   if (this.takedacode && !localStorage.TaToken) {
    //     this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
    //       localStorage.TaToken = msg.token
    //       localStorage.appId = msg.appId
    //       localStorage.openId = msg.openId
    //       this.openId = msg.openId
    //       this.routeQueries = this.$route.query
    //     })
    //   } else {
    //     this.openId = localStorage.openId
    //     this.routeQueries = this.$route.query
    //   }
    //   // if (!localStorage.openId) {
    //   //   this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
    //   //     localStorage.TaToken = msg.token
    //   //     localStorage.appId = msg.appId
    //   //     localStorage.openId = msg.openId
    //   //     this.openId = msg.openId
    //   //     this.routeQueries = this.$route.query
    //   //   })
    //   // } else {
    //   //   this.openId = localStorage.openId
    //   //   this.routeQueries = this.$route.query
    //   // }
    // }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/myPkFit/myPkIndex.vue